import { lazyWithRetry } from "utils/lazy-with-retry";
import { IGaiaObjectOverviewProps } from "./definitions";

const LazyGaiaObjectOverview = lazyWithRetry(
  () => import("./GaiaObjectOverview"),
);

const GaiaObjectOverview = (props: IGaiaObjectOverviewProps) => (
  <LazyGaiaObjectOverview {...props} />
);

export default GaiaObjectOverview;
